import { Persona, PersonaInsert } from "@moe/priv/model/persona";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";
import { toast } from "sonner";

/**
 * Hook for creating a new persona
 * @returns Mutation object for creating personas
 */
export function useCreatePersona() {
  const queryClient = useQueryClient();
  const { closeModal, access } = useAppContext();

  return useMutation({
    mutationFn: async (persona: PersonaInsert) => {
      return await access.persona.create(persona);
    },
    onSuccess: () => {
      toast.success("Successfully created persona");
      closeModal();
      queryClient.invalidateQueries({ queryKey: ["personas"] });
    },
    onMutate: async (newPersona) => {
      await queryClient.cancelQueries({ queryKey: ["personas"] });
      const prev = queryClient.getQueryData(["personas"]);
      queryClient.setQueryData(["personas"], (old: Persona[] = []) => {
        return [
          ...old,
          {
            ...newPersona,
            id: `temp-${Date.now()}`,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          }
        ];
      });
      closeModal();
      return { prev };
    },
    onError: (_err, _newPersona, context) => {
      queryClient.setQueryData(["personas"], context?.prev);
      toast.error("Error creating persona");
    }
  });
}
